module.exports = __webpack_public_path__ + "img/persona.d015c72e.png";